"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMuiStrictModeTheme;
var _utils = require("@mui/utils");
var _createTheme = _interopRequireDefault(require("./createTheme"));
function createMuiStrictModeTheme(options, ...args) {
  return (0, _createTheme.default)((0, _utils.deepmerge)({
    unstable_strictMode: true
  }, options), ...args);
}